import { Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';

export interface GoldenRuleBoxProps {
  text?: string;
  colSpan?: number;
}

export default function GoldenRuleBox({
  text = 'mediaPlanning.errors.goldenRule',
  colSpan = 9,
}: GoldenRuleBoxProps) {
  const { t } = useTranslation();

  return (
    <Grid item xs={colSpan}>
      <Box
        sx={{
          bgcolor: '#f00f00',
          height: '55px',
          borderRadius: '6px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mt: '-7px',
          p: '0 12px',
        }}
      >
        <ErrorOutlinedIcon
          sx={{ color: 'textLight.contrastText', mr: '10px' }}
        />
        <Typography
          variant="body1"
          sx={{
            color: 'textLight.contrastText',
          }}
        >
          {t(text)}
        </Typography>
      </Box>
    </Grid>
  );
}
